import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10" style={{background: 'linear-gradient(135deg, #fde7ee 0%, #e8f2fc 50%, #f6e7fb 100%)'}} />
      {/* decorative dots */}
      <svg className="absolute inset-0 w-full h-full -z-10 opacity-70" preserveAspectRatio="none" viewBox="0 0 1200 500" fill="none">
        <g stroke="#e5a4b7" strokeWidth="0.6" opacity="0.55">
          <line x1="40" y1="120" x2="180" y2="60" />
          <line x1="180" y1="60" x2="260" y2="200" />
          <line x1="40" y1="120" x2="260" y2="200" />
          <line x1="260" y1="200" x2="120" y2="340" />
          <line x1="120" y1="340" x2="40" y2="420" />
          <line x1="960" y1="80" x2="1080" y2="180" />
          <line x1="1080" y1="180" x2="1160" y2="320" />
          <line x1="960" y1="80" x2="1050" y2="260" />
          <line x1="1050" y1="260" x2="1160" y2="320" />
          <line x1="1050" y1="260" x2="940" y2="380" />
        </g>
        {[[40,120],[180,60],[260,200],[120,340],[40,420],[960,80],[1080,180],[1160,320],[1050,260],[940,380],[600,40],[720,440]].map(([cx,cy],i)=>(
          <circle key={i} cx={cx} cy={cy} r={i%3===0?4:2.5} fill={i%2===0?'#e63946':'#f4a3b6'} opacity={0.8} />
        ))}
      </svg>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-24 pb-28 text-center">
        <h1 className="text-[38px] md:text-[56px] lg:text-[64px] leading-[1.05] font-bold text-slate-900 tracking-tight">
          Scalable <span className="text-[#E63946]">SaaS,</span> Tailored for You
        </h1>
        <p className="mt-6 text-slate-700 text-base md:text-lg">
          Let AI Handle the Repetition, We'll Handle the Innovation
        </p>
        <Link to="/#contact" className="inline-block mt-10 bg-[#E63946] hover:bg-[#d02b38] text-white font-semibold px-8 py-4 rounded-full text-[15px] shadow-lg shadow-red-200 transition-colors">
          Let's Talk SaaS
        </Link>
      </div>
    </section>
  );
};

export default Hero;
